export default __webpack_public_path__ + "static/media/discord_username_how_to.bfc75d98.png";